

function Footer() {
  return (
    <div className="footer">
        Produzido por Marina Torres, 2026 ©
    </div>
  );
}

export default Footer;